export default __webpack_public_path__ + "static/media/msg.a63f2a44.svg";